import { Component, effect, inject, signal, untracked } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthService } from '@shared/util-auth';
import { ErrorMessage } from '@shared/util-error';

import { ClientConfigStore, CustomerStore, UserStore } from '@shared/data';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
  standalone: false
})
export class LayoutComponent {
  protected showErrorPage = signal(false);
  protected isLogoutPage = signal(window.location.pathname.startsWith('/logout'));
  private authService = inject(AuthService);
  private userStore = inject(UserStore);
  private customerStore = inject(CustomerStore);
  private translateService = inject(TranslateService);
  protected authenticated = false;
  private clientConfigStore = inject(ClientConfigStore);
  private router = inject(Router);

  constructor() {
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.isLogoutPage.set(event.urlAfterRedirects.startsWith('/logout'));
      }
    });

    effect(() => {
      const authenticated = this.authService.authenticated();
      const userLoaded = this.userStore.loaded();
      const corporatesLoaded = this.customerStore.availableCorporatesLoaded();
      untracked(() => {
        if (authenticated) {
          const cpMode = this.clientConfigStore.isLicoOrigin();
          if (!this.authService.roles || this.authService.roles.length === 0) {
            const errorMessage: ErrorMessage = {
              summary: this.translateService.instant('shared.error.notAuthorized.summary', { application: cpMode ? 'LICo' : 'LiOn' }),
              detail: this.translateService.instant('shared.error.notAuthorized.detailNoRoles')
            };
            this.showErrorPage.update(() => true);
            this.router.navigate(['/error'], { state: errorMessage }).then();
          } else if (userLoaded && (!this.userStore.isCorporateMode() || this.userStore.isDzBankUser() || corporatesLoaded)) {
            if (this.userStore.isCorporateMode() && !this.userStore.isDzBankUser() && this.customerStore.suggestedCustomers().length == 0) {
              const errorMessage: ErrorMessage = {
                summary: this.translateService.instant('shared.error.notAuthorized.summary', { application: cpMode ? 'LICo' : 'LiOn' }),
                detail: this.translateService.instant('shared.error.notAuthorized.detailNoCustomers')
              };
              this.showErrorPage.update(() => true);
              this.router.navigate(['/error'], { state: errorMessage }).then();
            } else {
              this.authenticated = true;
              console.info(`User is authenticated, staying on current route: ${this.router.url}`);
            }
          }
        }
      });
    });
  }

  backToLogin() {
    this.authService.logout(false);
  }
}
